/**
 * Utility functions for user-related operations
 */

/**
 * Extracts TE-ID from user email if it contains the pattern TE-XXXXXXXX
 * @param email - User email address
 * @returns TE-ID string if found, null otherwise
 */
export const extractTEIdFromEmail = (email: string): string | null => {
  const teIdPattern = /TE-\d{8}/;
  const match = email.match(teIdPattern);
  return match ? match[0] : null;
};

/**
 * Checks if a user is a Certified Organization (CO) based on their email
 * @param email - User email address
 * @returns true if user is a CO (email contains TE-ID), false otherwise
 */
export const isUserCertifiedOrganization = (email: string): boolean => {
  return extractTEIdFromEmail(email) !== null;
};
